import axios from 'axios';

export function setMicrositeColour(site) {
  axios.get(`https://www.mshgroups.com/siteColour/${site}`, {})
  .then(function (response) {
    setColour(response.data, 'primary');
    setColour(response.data, 'secondary');
    sessionStorage.setItem('microsite_colour', response.data);
  })
}

export function setColour(colour, type) {
  const root = document.documentElement;
  root.style.setProperty(`--client-${type}`, colour);
}


// WEBPACK FOOTER //
// ./src/helpers/style.js